import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Suspense, lazy } from 'react'

import AppLayout from '../layouts/appLayout'
import AuthLayout from '../layouts/authLayout'
import NotFound from './auth/NotFound'

const Profile = lazy(() => import('./app/Profile'))
const Home = lazy(() => import('./app/Home'))
const Sites = lazy(() => import('./app/site/Sites'))
const Clients = lazy(() => import('./app/client/Clients'))
const Preferences = lazy(() => import('./app/preferences/Preferences'))
import Members from './app/member/Members'
import Equipments from './app/equipment/Equipments'
import Exams from './app/procedure/Exams'
import Login from './auth/Login'
import ForgottenPassword from './auth/ForgottenPassword'
import ResetPassword from './auth/ResetPassword'
import VerificationEmail from './auth/VerificationEmail'
import Ambulances from './app/ambulance/Ambulances'
import Rooms from './app/room/Rooms'
import Receptions from './app/room/receptions/Receptions'
import WaitingRooms from './app/room/waiting_rooms/WaitingRooms'
import ExamRoom from './app/room/ExamRoom'
import PrepRoom from './app/room/PrepRoom'
import Offices from './app/room/office/Offices'
import {Roles} from './app/role-permission/Roles'
import Questions from './app/questions/Questions'
import Stats from './app/stats/Stats'
import Billing from './app/billing/Billing'
import Logs from './app/log/Logs'
import MedicalOrderTransport from './app/ambulance/MedicalOrderTransport'
import Worklists from './app/Worklists/Worklists'
import ResipLayout from '../layouts/ResipLayout'
import ParamterContainer from './app/parameters/ParamterContainer'
import Settings from './app/settings/Settings'
import { Scheduling } from './app/scheduling/Scheduling'
import { WaitingRoom } from './app/waiting_room/WaitingRoom'
import AcqusitionProtocols from './app/acquisition_protocols/AcqusitionProtocols'
import Mss from './app/mss/Mss'
import { FunctionalUnitContainer } from '../components/functionalUnit/FunctionalUnitContainer'
import FacilityManagement from './app/facility-management/FacilityManagement'
import Organisations from './app/facility-management/Organisations'
import LabWorkstations from './app/room/labWorkstation/LabWorkstations'
import ReportShellPage from '@components/reports/ReportShellPage'
import ShellReportLayout from '../layouts/shellReportLayout'
import Radiopharmacy from './app/radiopharmacy/Radiopharmacy'
import RadiopharmacyOperations from './app/radiopharmacy/RadiopharmacyOperations'
import PrescriptionsTable from '@components/tables/PrescriptionsTable'
import RadiopharmacyWaste from './app/radiopharmacy/RadiopharmacyWaste'

export default function Router() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/auth" element={<AuthLayout />}>
            <Route path="login" element={<Login />} />
            <Route path="forgotten-password" element={<ForgottenPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="verification-mail" element={<VerificationEmail />} />
          </Route>
          <Route path="/report-shell" element={<ShellReportLayout />}>
            <Route path="" element={<ReportShellPage />} />
          </Route>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Worklists />} />
            <Route path="profile" element={<Profile />} />
            <Route path="sa">
              <Route index element={<Home />} />

              <Route path="clients" element={<Clients />}>
                <Route path=":clientId" element={<Preferences />} />
              </Route>
            </Route>
            <Route path="/ambulances">
              <Route path="" element={<Ambulances />} />
              <Route
                path="assign-transport"
                element={<MedicalOrderTransport />}
              />
            </Route>
            <Route path="parameters" element={<ParamterContainer />} />

            <Route path="m">
              <Route index element={<Home />} />
              <Route path="worklist" element={<Worklists />} />

              <Route path="roles" element={<Roles />} />
              <Route path="equipment" element={<Equipments />} />
              <Route path="equipements" element={<Equipments />} />
              <Route path="logs" element={<Logs />} />
              <Route path="members" element={<Members />} />
              <Route path="procedures" element={<Exams />} />
              <Route path="questions" element={<Questions />} />
              <Route path="preferences" element={<Preferences />} />
              <Route path="billing" element={<Billing />}></Route>
              <Route path="appointments" element={<Scheduling />} />
              <Route path="waiting-room" element={<WaitingRoom />} />
              <Route path="radiopharmacy" element={<Radiopharmacy />}>
                <Route index element={<Navigate to="operation" replace />} />
                <Route path="operation" element={<RadiopharmacyOperations />} />
                <Route path="prescription" element={<PrescriptionsTable />} />
                <Route path="waste" element={<RadiopharmacyWaste />} />
              </Route>
              <Route path="settings/*" element={<Settings />} />
              <Route path="mss" element={<Mss />} />
              <Route path="preferences" element={<Preferences />} />
              <Route path="stats" element={<Stats />} />
              <Route path="facility" element={<FacilityManagement />}>
                <Route index element={<Sites />} />
                <Route path="sites" element={<Sites />} />
                <Route path="rooms" element={<Rooms />}>
                  <Route index element={<Receptions />} />
                  <Route path="receptions" element={<Receptions />} />
                  <Route path="waiting-rooms" element={<WaitingRooms />} />
                  <Route path="exam-rooms" element={<ExamRoom />} />
                  <Route path="prep-rooms" element={<PrepRoom />} />
                  <Route path="offices" element={<Offices />} />
                  <Route
                    path="lab-workstations"
                    element={<LabWorkstations />}
                  />
                </Route>
                <Route
                  path="functional-units"
                  element={<FunctionalUnitContainer />}
                />
                <Route path="organisations" element={<Organisations />} />
              </Route>
              <Route path="fse/resip" element={<ResipLayout />}></Route>
              <Route
                path="acquisition-protocols"
                element={<AcqusitionProtocols />}
              ></Route>
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
